import React from 'react';
import { CheckCircle } from 'lucide-react';

const CustomSuccessPlan = () => {
  const examples = [
    {
      scenario: 'Sales org rolling out objection handling role plays weekly',
      icon: '💼'
    },
    {
      scenario: 'Support team reducing onboarding time by standardizing training',
      icon: '🎧'
    },
    {
      scenario: 'High-volume recruiting pipeline with automated interview scoring',
      icon: '📊'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-900">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-6">
            Your business is unique.
            <br />
            <span className="text-blue-400">Your plan should be too.</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We don't force you into a template. We map Traain to your goals — whether you're scaling hiring, driving coaching consistency, or launching a new enablement motion.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {examples.map((example, index) => (
            <div
              key={index}
              className="bg-gray-800 rounded-xl p-6 border border-gray-700 hover:border-blue-700 transition-colors"
            >
              <div className="text-4xl mb-4">{example.icon}</div>
              <p className="text-gray-300">{example.scenario}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 rounded-2xl p-8 border border-blue-800 text-center">
          <CheckCircle className="w-12 h-12 text-blue-400 mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-white mb-3">
            We start with your goals, not our features.
          </h3>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Every onboarding begins with discovery. We listen, ask questions, and design a plan that fits your reality — not a generic playbook.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CustomSuccessPlan;